import { Link } from "react-router-dom";
import { PageHero } from "../../components/PageHero";
import { ScrollReveal } from "../../components/ScrollReveal";
import { Seo } from "../../components/Seo";
import { useLanguage } from "../../i18n/LanguageProvider";

const PillList = ({ items }: { items: string[] }) => (
  <ul className="gw-pill-list" style={{ marginTop: "1rem" }}>
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

/** Institutional and corporate collaborations from the revised content document. */
export const PartnershipsPage = () => {
  const { t, tList, path } = useLanguage();

  return (
    <>
      <Seo
        titleKey="meta.partnerships.title"
        descriptionKey="meta.partnerships.description"
      />

      <PageHero
        variant="partnerships"
        eyebrow={t("partnerships.eyebrow")}
        title={t("partnerships.title")}
        subtitle={t("partnerships.subtitle")}
      />

      <section className="gw-section">
        <div className="gw-container">
          <ScrollReveal>
            <p className="gw-lead gw-prose">{t("partnerships.intro")}</p>
          </ScrollReveal>

          <div className="gw-grid gw-grid--2" style={{ marginTop: "2.5rem" }}>
            <ScrollReveal>
              <article
                className="gw-card"
                style={{ height: "100%", padding: "var(--gw-space-6)" }}
              >
                <h2 style={{ fontSize: "var(--gw-text-xl)" }}>
                  {t("partnerships.universities.title")}
                </h2>
                <p
                  style={{ marginTop: "0.75rem", color: "var(--gw-ink-muted)" }}
                >
                  {t("partnerships.universities.body")}
                </p>
                <p
                  style={{ marginTop: "0.75rem", color: "var(--gw-ink-muted)" }}
                >
                  {t("partnerships.universities.detail")}
                </p>
                <PillList items={tList("partnerships.universities.points")} />
              </article>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <article
                className="gw-card"
                style={{ height: "100%", padding: "var(--gw-space-6)" }}
              >
                <h2 style={{ fontSize: "var(--gw-text-xl)" }}>
                  {t("partnerships.schools.title")}
                </h2>
                <p
                  style={{ marginTop: "0.75rem", color: "var(--gw-ink-muted)" }}
                >
                  {t("partnerships.schools.body")}
                </p>
                <PillList items={tList("partnerships.schools.points")} />
              </article>
            </ScrollReveal>
          </div>

          <ScrollReveal delay={120}>
            <article
              className="gw-card gw-card--feature"
              style={{
                marginTop: "var(--gw-space-5)",
                padding: "var(--gw-space-6)",
              }}
            >
              <span className="gw-badge gw-badge--on-dark">
                {t("partnerships.resilientSchool.badge")}
              </span>
              <h2
                style={{
                  fontSize: "var(--gw-text-xl)",
                  marginBlock: "0.9rem 0.75rem",
                }}
              >
                {t("partnerships.resilientSchool.title")}
              </h2>
              <div className="gw-grid gw-grid--2">
                <p style={{ color: "rgb(255 255 255 / 82%)" }}>
                  {t("partnerships.resilientSchool.body")}
                </p>
                <p style={{ color: "rgb(255 255 255 / 82%)" }}>
                  {t("partnerships.resilientSchool.detail")}
                </p>
              </div>
              <PillList items={tList("partnerships.resilientSchool.points")} />
            </article>
          </ScrollReveal>
        </div>
      </section>

      <section className="gw-section gw-section--sunken">
        <div className="gw-container">
          <ScrollReveal>
            <h2 className="gw-title">{t("partnerships.corporate.title")}</h2>
            <p className="gw-subtitle">{t("partnerships.corporate.body")}</p>
          </ScrollReveal>

          <div className="gw-grid gw-grid--2" style={{ marginTop: "2.5rem" }}>
            <ScrollReveal>
              <div className="gw-card" style={{ height: "100%" }}>
                <h3 style={{ fontSize: "var(--gw-text-lg)" }}>
                  {t("partnerships.corporate.formsHeading")}
                </h3>
                <PillList items={tList("partnerships.corporate.forms")} />
              </div>
            </ScrollReveal>
            <ScrollReveal delay={100}>
              <div className="gw-card" style={{ height: "100%" }}>
                <h3 style={{ fontSize: "var(--gw-text-lg)" }}>
                  {t("partnerships.corporate.topicsHeading")}
                </h3>
                <PillList items={tList("partnerships.corporate.topics")} />
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal delay={150}>
            <p className="gw-lead gw-prose" style={{ marginTop: "2rem" }}>
              {t("partnerships.corporate.closing")}
            </p>
          </ScrollReveal>
        </div>
      </section>

      <section className="gw-section gw-section--gradient">
        <div
          className="gw-container gw-container--narrow"
          style={{ textAlign: "center" }}
        >
          <ScrollReveal>
            <h2 className="gw-title">{t("partnerships.ctaTitle")}</h2>
            <p className="gw-subtitle" style={{ marginInline: "auto" }}>
              {t("partnerships.ctaBody")}
            </p>
            <p style={{ marginTop: "1.75rem" }}>
              <Link to={path("/contact")} className="gw-btn gw-btn--on-dark">
                {t("partnerships.ctaButton")}
              </Link>
            </p>
          </ScrollReveal>
        </div>
      </section>
    </>
  );
};
